import { useReactToPrint } from 'react-to-print';
import { PrintOutlined as Print } from '@material-ui/icons';
import { withStyles } from '@material-ui/core';
import Tooltip from '../StyledToolTip';

const styles = (theme) => ({
  headerIconStyles: {
    padding: '5px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: 'pointer',
    color: theme.iconColor
  }
});

const PrintIcon = ({
  classes,
  tooltipText,
  printRef,
  onBeforeGetContent = null,
  onAfterPrint = null
}) => {
  const handlePrintClick = (e) => {
    e.stopPropagation();
    handlePrint();
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onBeforeGetContent: onBeforeGetContent,
    copyStyles: true,
    onAfterPrint: onAfterPrint,
    pageStyle: 'print'
  });

  return (
    <Tooltip title={tooltipText}>
      <Print className={classes.headerIconStyles} onClick={handlePrintClick} />
    </Tooltip>
  );
};

export default withStyles(styles)(PrintIcon);
